
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      vxSearchPageTitle: 'search/getSearchPageTitle',
      vxCollectionTitle: 'search/getCollectionTitle',
      vxPageDescription: 'search/getPageDescription',
      vxCurrency: 'currency/getCurrency',
    }),
    pageTitle() {
      const wording = this.vxCollectionTitle || this.vxSearchPageTitle
      if (wording?.includes('$') && this.vxCurrency === 'EUR')
        return wording.replaceAll('$', '€')
      else return wording
    },
  },
}
